import ViewerImgButton from './viewerImgButton';
export default ViewerImgButton;
